
import { SyntheticEvent, useEffect, useState } from 'react'
import appInfo from '../../../configs/app-info';
import apiUrl from '../../../configs/constant';
import { getDoctag, getCustomer, getSales, getDesigner, getProduct } from '../../../api/helper';
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Controller, useForm } from 'react-hook-form'
import { Autocomplete, Box, Button, Divider, Fab, FormControl, FormHelperText, IconButton, TextField, Tooltip } from '@mui/material';
import MsiDatagrid from '../../custom/MsiDatagridAuto';
import Icon from '../../icon';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useToast } from '../../ToastProvider';
import DialogBiayaLainnya from '../../acc/accarr/DialogBiayaLainnya';

interface Props {
    id: any
    onClose: () => void
}

const terbilang = (nominal: number) => {
    if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

    const satuan = ['', 'SATU', 'DUA', 'TIGA', 'EMPAT', 'LIMA', 'ENAM', 'TUJUH', 'DELAPAN', 'SEMBILAN', 'SEPULUH', 'SEBELAS']

    const penyebut = (n: number): string => {
        if (n < 12) return satuan[n]
        if (n < 20) return `${penyebut(n - 10)} BELAS`
        if (n < 100) return `${penyebut(Math.floor(n / 10))} PULUH ${penyebut(n % 10)}`
        if (n < 200) return `SERATUS ${penyebut(n - 100)}`
        if (n < 1000) return `${penyebut(Math.floor(n / 100))} RATUS ${penyebut(n % 100)}`
        if (n < 2000) return `SERIBU ${penyebut(n - 1000)}`
        if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} RIBU ${penyebut(n % 1000)}`
        if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} JUTA ${penyebut(n % 1000000)}`
        if (n < 1000000009) return `${penyebut(Math.floor(n / 1e9))} MILIAR ${penyebut(n % 1e9)}`
        return 'Angka terlalu besar'
    }

    const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

    return `${result} RUPIAH`
}

export default function DetailInvoice({ id }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogDeliveryOrder, setOpenDialogDeliveryOrder] = useState<boolean>(false)
    const [listDeliveryOrder, setListDeliveryOrder] = useState<any[]>([])
    const [editDetail, setEditDetail] = useState<boolean>(false)

    const [listBiaya, setListBiaya] = useState<any[]>([])
    const [listHistory, setListHistory] = useState<any[]>([])
    const [openBiayaLainnya, setOpenBiayaLainnya] = useState(false)

    const [openDialogDP, setOpenDialogDP] = useState<boolean>(false)

    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    useEffect(() => {
        getData()
        // fetchCombo('/mm/jenis-barang/list-combo', setJenisOptions)
    }, [])


    const fetchCombo = (endpoint: string, setter: (data: any[]) => void) => {
        axios
            .get(apiUrl.apiUrl + endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setter(res.data.data)
            })
    }
    const getListDeliveryOrder = () => {
        const sdcust_id = getValues('sdcust_id');
        const url = apiUrl.apiUrl + '/acc/invoice/list-open-delivery-order'
        axios
            .get(url, {
                params: { sdcust_id: sdcust_id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDeliveryOrder(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    // Komponen kecil untuk 1 item informasi
    const InfoItem = ({ label, value }: { label: string; value: string | number }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value || "-"}
            </Typography>
        </Box>
    );

    const rowClickDeliveryOrder = (e: any) => {
        const data = e.data
        setOpenDialog(false)

        const payload = {
            accinv_id: id,
            sddo_id: data.id,
        }
        const url = apiUrl.apiUrl + '/acc/invoice/add-invoice-detail'
        axios
            .post(url, payload, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {

                    showToast(response.data.message, 'success');
                    getDetail();
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/acc/invoice/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)

                    getBiayaLainnya()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getBiayaLainnya = () => {
        axios.get(apiUrl.apiUrl + '/acc/invoice/get-biaya-lainnya', {
            params: { id },
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            if (res.data.success) {
                const data = res.data.data
                setListBiaya(data)

                getHistory()
            }
        })
    }

    const getHistory = () => {
        axios.get(apiUrl.apiUrl + '/acc/invoice/get-history', {
            params: { id },
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            if (res.data.success) {
                const data = res.data.data.map((row: any, index: any) => ({
                    dp_id: row.id,
                    ...row
                }));
                setListHistory(data)
            }
        })
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/acc/invoice/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('dokumen', data.dokumen)
                    setValue('tgl', data.tgl)
                    setValue('tgl_jth_tempo', data.tgl_jth_tempo)
                    setValue('nama_customer', data.nama_customer)
                    setValue('alamat', data.alamat)
                    setValue('nomor_faktur', data.nomor_faktur)
                    setValue('keterangan', data.keterangan)
                    setValue('accinv_id', data.accinv_id)
                    setValue('sdcust_id', data.sdcust_id)
                    setValue('total_valas_ppn', data.total_valas_ppn)

                    setSelectedData({ sdcust_id: data.sdcust_id, customer: data.nama_customer })

                    getDetail()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetailDP = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const resetDetail = () => {
        setValue('accinv_d_id', 0)
        setValue('qtyDetail', '')
        setValue('keteranganDetail', '')
        setValue('namaProductDetail', '')
        setValue('kodeProductDetail', '')
        setValue('hargaProductDetail', '')
    }

    interface FormInputs {
        syscabang_id: number;
        sysdoctag_id: number;
        dokumen: string;
        tgl: any;
        tgl_jth_tempo: any;
        nama_customer: string;
        alamat: string;
        nomor_faktur: string;
        keterangan: string;
        accinv_id: number;
        accinv_d_id: number;
        sdcust_id: number;
        sddo_d_id: number;
        kodeProductDetail: any;
        namaProductDetail: any;
        hargaProductDetail: any;
        qtyDetail: any;
        keteranganDetail: any;
        total_valas_ppn: any
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    resetDetail();
                    setValue('accinv_d_id', row.id);
                    setValue('sddo_d_id', row.sddo_d_id);
                    setValue('qtyDetail', row.qty);
                    setValue('keteranganDetail', row.keterangan);
                    setValue('namaProductDetail', row.nama);
                    setValue('kodeProductDetail', row.kode);
                    setValue('hargaProductDetail', row.harga);
                    setOpenDialogDeliveryOrder(true);
                    setEditDetail(true);
                }
            },
            {
                title: "Hapus Invoice",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/invoice/delete-accinv-d/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getDetail()
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    const actionDataBiaya = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 80,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Hapus" placement="top">
                        <IconButton onClick={() => {
                            Swal.fire({
                                title: 'Konfirmasi',
                                text: 'Hapus biaya lainnya?',
                                icon: 'question',
                                showCancelButton: true
                            }).then(result => {
                                if (result.isConfirmed) {
                                    let url = apiUrl.apiUrl + '/acc/invoice/delete-biaya-lainnya/' + row.id
                                    axios.post(url, {}, {
                                        headers: { Authorization: `Bearer ${token}` }
                                    }).then(res => {
                                        showToast(res.data.message, 'success')
                                        getBiayaLainnya()
                                    })
                                }
                            })
                        }}>
                            <Icon icon={"mdi:trash-can-outline"} color={"red"} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    setSelectedData(row.data)
                                    setOpenDialogDP(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<Icon icon="mdi:eye" />}
                                    onClick={() => {
                                        setOpenDialogDP(true)
                                        getDetailDP(row.data.dp_id)
                                    }}
                                >
                                    Lihat DP <br />
                                    {row.data.dp_id}
                                </Button>
                            </>
                        )}
                    </Box>
                )
            }
        }
    ];

    return (
        <>
            <form>
                <Grid container spacing={2} sx={{ ml: 3, mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Dokumen" value={watch("dokumen")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Tanggal" value={watch("tgl")} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InfoItem label="Tanggal" value={watch("tgl")}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Tanggal Jatuh Tempo" value={watch("tgl_jth_tempo")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Nama Customer" value={watch("nama_customer")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Nomor Faktur" value={watch("nomor_faktur")} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <InfoItem label="Alamat" value={watch("alamat")} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <InfoItem label="Keterangan" value={watch("keterangan")} />
                    </Grid>
                </Grid>
            </form>
            <Box
                sx={{
                    mt: 1,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        mb: 1
                    }}
                >
                    <Typography fontWeight="bold" fontSize={25}>
                        Grand Total : &nbsp;
                    </Typography>

                    <Typography fontWeight="bold" fontSize={25}>
                        Rp. {Number(getValues('total_valas_ppn') || 0).toLocaleString('id-ID')}
                    </Typography>
                </Box>

                {/* Terbilang */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        mb: 1
                    }}
                >
                    <Typography fontWeight="bold" fontSize={25}>
                        Terbilang : &nbsp;
                    </Typography>

                    <Typography
                        fontWeight="bold"
                        fontSize={25}
                    >
                        {terbilang(getValues('total_valas_ppn') ? getValues('total_valas_ppn') : 0)}
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ mt: 3 }} />
            <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
                    <Button variant="contained" color="primary"
                        onClick={() => {
                            resetDetail()
                            setEditDetail(false)
                            getListDeliveryOrder()
                            setOpenDialog(true)
                        }}>
                        Tambah Delivery Order Detail
                    </Button>
                </Box>
                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                    LIST INVOICE ITEM
                </Typography>
                <Box sx={{ overflowX: 'auto' }}>
                    <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
                    <Button variant="contained" color="primary"
                        onClick={() => {
                            setOpenBiayaLainnya(true)
                        }}>
                        Tambah Biaya Lain lain
                    </Button>
                </Box>
                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                    LIST BIAYA LAIN-LAIN
                </Typography>
                <Box sx={{ overflowX: 'auto' }}>
                    <MsiDatagrid key={1} array={listBiaya} actions={actionDataBiaya} />
                </Box>
                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                    HISTORY
                </Typography>
                <Button
                    variant="contained"
                    color="warning"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        setDialogMode('add-from-list')
                        setSelectedData(listHistory.length > 0 ? listHistory[0] : selectedData)
                        setOpenDialogDP(true)
                    }}
                >
                    Tambah DP
                </Button>
                <Box sx={{ overflowX: 'auto' }}>
                    <MsiDatagrid key={1} array={listHistory} customRender={convertComponent} hiddenColumns={['id', 'default_dp', 'default_dp_pesan']} />
                </Box>
            </Box>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Delivery Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <MsiDatagrid array={listDeliveryOrder} rowClick={rowClickDeliveryOrder} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogDeliveryOrder}
                onClose={() => setOpenDialogDeliveryOrder(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/acc/invoice/edit-delivery-order/' + data.accinv_d_id;
                    } else {
                        url = apiUrl.apiUrl + '/acc/invoice/save-delivery-order/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.accinv_d_id : data.sddo_d_id,
                        notes: data.keteranganDetail,
                        harga: data.hargaProductDetail
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');

                                setOpenDialogDeliveryOrder(false);
                                getDetail(); // Refresh the detail list
                                getData(); // Refresh the main data
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogDeliveryOrder(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            {editDetail ? "Edit" : "Tambah"} Delivery Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {editDetail ?
                                <Grid item xs={12} md={12}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='accinv_d_id'
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    value={value}
                                                    label='ID Detail'
                                                    type='number'
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={onChange}
                                                    InputProps={{ readOnly: true }} // Make the input read-only
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid> : null}
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='namaProductDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Nama Product'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kodeProductDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode Product'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hargaProductDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Harga'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.hargaProductDetail)}
                                                InputProps={{ readOnly: false }} // Make the input read-only
                                            />
                                        )}
                                    />
                                    {errors.hargaProductDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Harga harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keteranganDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogDeliveryOrder(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <DialogBiayaLainnya
                id={id}
                tabel='accinv'
                open={openBiayaLainnya}
                onClose={() => setOpenBiayaLainnya(false)}
                onReload={() => {
                    getDetail()
                }}
            />
        </>
    )
}
